export default __webpack_public_path__ + "static/media/H91A1595.e879c2ad.jpg";